<template id="post">
  <article class="post" :class="{ active: getActive, hovered: getHovered }">
    <div
      @click="openPost()"
      class="post-container"
      :style="{ backgroundImage: 'url(' + getCover(event.cover) + ')' }"
      :class="{ cover: event.cover }"
    >
      <p
        class="post-title"
        v-if="event.title"
        :class="{ 'post-title_small': event.title.length > 70 }"
      >
        {{ event.title | cutString(99) }}
      </p>
      <div class="post-info__date" :class="getStatus(event.date_event, event.closed_plan)">
        <p>{{ getDate() }}</p>
      </div>
      <div class="categoryy" v-if="event.sports">
        <div class="categoryy-more" v-if="event.sports.length > 4">
          + {{ event.sports.length - 4 }}
        </div>
        <div
          v-for="(cat, index) in event.sports.slice(0, 4)"
          :key="cat.id"
          :v-if="index < 3"
          class="categoryy-item"
          :class="cat.color"
          @click.stop.prevent="setFilter(cat)"
        >
          {{ cat.ru }}
        </div>
      </div>
      <div class="post-info">
        <div class="post-info-wrap">
          <p class="post-info__place" @click="openPlace()" v-if="event.place">
            {{ event.place.title | cutString(20) }}
          </p>
          <p class="post-info__place" v-else-if="event.latitude && event.longitude">
            {{ (this.event.country && this.event.state ? this.event.country + ', ' + this.event.state : event.latitude + ', ' + event.longitude) | cutString(22) }}
          </p>
          <p class="post-info__place" v-else>Без места</p>
          <p class="post-info__tag" v-if="event.tags">{{ event.tags }}</p>
        </div>
        <div class="post-info-wrap">
          <div class="post-info__flame" v-if="getHotLevel && event.users && event.users.length > getHotLevel">
            <img src="@/assets/images/icons/icon_flame.svg" />
          </div>
          <div
            class="post-info__user"
            :class="{'offset-left': event.users.length > 0}"
            @click="openAuthor()"
            v-if="event.author"
            :style="{ backgroundImage: 'url(' + event.author.avatar + ')' }"
          >
            <span v-if="event.users && event.users.length > 0">+{{ event.users.length }}</span>
          </div>
        </div>
      </div>
    </div>
    
  </article>
</template>

<script>
import moment from 'moment';
import { commonFilters, statuses } from '@/mixins.js';

export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    active: false,
    window_width: undefined
  }),
  mixins: [commonFilters, statuses],
  computed: {
    getEvent() {
      return this.$store.getters.getActiveEvent;
    },
    getActive() {
      return this.getEvent && this.event && !this.getMode && this.getEvent.id === this.event.id;
    },
    getHovered() {
      return this.getEvent && this.event && this.getEvent.id === this.event.id;
    },
    getHotLevel() {
      return this.$store.getters.getHotLevel;
    },
    getMode() {
      return this.$store.getters.getMode;
    }
  },
  methods: {
    getCover(cover) {
      let thumbnail = cover && cover.indexOf('.webp') != -1 ? cover.split('.webp')[0] : cover;
      thumbnail += '-thumbnail.webp';
      return thumbnail || cover
    },
    setFilter(cat) {
      cat.active = true;
      this.$store.dispatch('changeSports', cat);
    },
    async openPost() {
      this.$store.dispatch('changeState', { element: 'filters', val: false });
      let hash = this.$route.params.hash;
      this.$store.dispatch('setMapZoom', 14);

      if (hash && (hash == this.event.hash || hash.split('&')[1] == this.event.hash)) {
        this.$store.dispatch('changeMode', false);
      } else if (!(this.event.place || (this.event.latitude && this.event.longitude))) {
        if (this.window_width < 1024) {
          await this.$router.push({
            name: 'event',
            params: { hash: this.event.id + '&' + this.event.hash },
          });
          await this.$store.dispatch('changeMode', false);

        } else {

          this.$store.dispatch('changeMode', false);
          this.$router.push({
            name: 'event',
            params: { hash: this.event.id + '&' + this.event.hash },
          });
        }
      } else {
        if (this.window_width < 1024) {
          await this.$store.dispatch('setActiveEvent', null);
        }
        await this.$router.push({
          name: 'event',
          params: { hash: this.event.id + '&' + this.event.hash },
        });
        if (this.window_width < 1024) {
          await this.$store.dispatch('changeMode', false);
        } 
      }
    },
    getDate() {
      let status = this.getStatus(this.event.date_event, this.event.closed_plan);
      let date = moment(this.event.date_event).locale('ru').calendar();

      if (status === 'active') {
        date = moment(this.event.closed_plan).locale('ru').calendar();
        date = 'До ' + date
        date = date.replace('в ', '')
      }
      date = date.replace('следующую', 'сл.')
      date = date.replace('следующий', 'сл.')
      date = date.replace('следующее', 'сл.')
      date = date.replace('прошлое', 'прош.')
      date = date.replace('прошлую', 'прош.')
      date = date.replace('прошлый', 'прош.')
      return date;
    },
    openAuthor() {
      let link = this.$router.resolve({
        name: 'user',
        params: { id: this.event.author.id },
      });
      window.open(link.href, '_blank');
    },
    openPlace() {
      let link = this.$router.resolve({
        name: `place`,
        params: { hash: this.event.place.id + '&' + this.event.place.hash },
      });
      window.open(link.href, '_blank');
    },
    updateWidth() {
      this.window_width = window.innerWidth;
    }
  },
  mounted() {
    this.updateWidth()
    this.active = this.getEvent === this.event ? true : false;
  },
  created() {
    window.addEventListener('resize', this.updateWidth);
  }
};
</script>
<style lang="stylus">
.post
  width 100%
  max-width 600px
  min-width 300px
  min-height 185px
  position relative
  cursor pointer
  margin-top 20px
  // box-shadow 0px 0px 15px rgba(162, 162, 162, 0.3)
  // border-radius 20px
  // animation fadeInUp 0.4s alternate
  // animation-delay 0
  +to-width(1023px)
    margin 10px
    width calc(33.333% - 20px)
    min-width 275px
  +to-width(1000px)
    margin 10px
    width calc(50% - 20px)
    min-width 275px
  +to-width(720px)
    margin 5px 0
    width calc(100% - 20px)
    max-width 360px
    min-width 275px
    margin-left auto
    margin-right auto
  +to-width(460px)
    max-width initial
    width 100%
  // &:after
  //   content ''
  //   position absolute
  //   bottom 0px
  //   left 15px
  //   right 15px
  //   height 30px
  //   border-radius 20px
  //   background-color #fbf2db
  //   background-color #20859b
  //   z-index 2
  //   t()
  // &:before
  //   content ''
  //   position absolute
  //   bottom 0px
  //   left 30px
  //   right 30px
  //   height 30px
  //   border-radius 20px
  //   background-color #f6eed7
  //   background-color #2e5364
  //   z-index 1
  //   t()
  &:first-child
    margin-top 0
    +to-width(1023px)
      margin-top 10px

  &:hover
    &:after
      bottom -8px

  &:active
    &:before
      bottom -15px

  &.hovered
    &:after
      bottom -8px
      
  &.active
    &:after
      bottom -8px
    &:before
      bottom -15px

  &-help
    position absolute
    right -100%

  &-title
    font-size 18px
    font-weight 600
    letter-spacing 0.2px
    line-height 26px
    color var(--main)
    position relative
    z-index 2
    +to-width(1400px)
      font-size 18px
      line-height 28px
    
    &_small
      font-size 14px
  
  &-container
    position absolute
    padding 15px 30px
    display flex
    align-items center
    left 0
    right 0
    top 0
    bottom 0
    z-index 3
    background-color #fff7e1
    border-radius 30px
    background-size cover
    background-position top center
    content-visibility auto
    overflow hidden
    +to-width(1400px)
      padding 15px 20px

    .post-info
      z-index 2
    .category
      z-index 3
    
    &.cover
      .post-title
        color white
      .post-info__adress
        opacity 1
        color white
      .post-info__place
        color white
        opacity 0.6
      .post-info__tag:after
        background white
      .post-info__place:after
        background white
      .post-info__user
        span
          border 1px solid white
      &:after
        content ''
        left 0
        right 0
        top 0
        bottom 0
        position absolute
        background-color rgba(0,0,0,0.4)
    
      

@keyframes fadeInUp{
  0% {
    opacity 0
    transform translateY(20px)
  }
  100%{
    opacity 1
    transform translateY(0px)
  }
}
</style>